import { render, staticRenderFns } from "./VehicleAndCustomerDetailBox.vue?vue&type=template&id=a444784a&scoped=true&lang=pug"
import script from "./VehicleAndCustomerDetailBox.vue?vue&type=script&lang=js"
export * from "./VehicleAndCustomerDetailBox.vue?vue&type=script&lang=js"
import style0 from "./VehicleAndCustomerDetailBox.vue?vue&type=style&index=0&id=a444784a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a444784a",
  null
  
)

export default component.exports